export default __webpack_public_path__ + "static/durable-and-long-lasting-diesel-repair-ac162b8233af258639088ff0a14074ef.jpg";